import React, { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { isFeatureAvailable } from "../../_utils/common";
import TldrUpgradeSubscriptionModal from "./modals/TldrUpgradeSubscriptionModal";
import { FeatureCodes } from "../details/constants";
import { includedFeatures } from "../../_utils/constants";
import { FaCheckDouble, FaFileSignature, FaPenAlt } from "react-icons/fa";
import aiLongFormArtBoard from "../../assets/images/aiLongFormArtBoard.jpeg";
import i18next from "i18next";

const FeatureAvailabilityWrapper = (WrappedComponent) => {
  return class extends Component {
    constructor(props) {
      super(props);

      this.state = {
        show: false,
        feature: "",
      };
    }

    checkFeatureAvailability = (feature, callback, fileType) => {
      this.setState({
        feature,
      });
      const isAvailable = isFeatureAvailable(
        this.props.subscription || {},
        feature
      );

      if (
        (fileType && fileType === "svg" && !isAvailable) ||
        (fileType && fileType === "video" && !isAvailable) ||
        (!fileType && !isAvailable)
      ) {
        this.setState({
          show: true,
        });
      } else {
        callback && callback();
      }
      return isAvailable;
    };

    getFeatureLockModalTitle = () => {
      const { feature } = this.state;
      const { t } = i18next;
      let title = "";

      switch (feature) {
        case FeatureCodes.BACKGROUND_REMOVER:
          title = t("feature_codes.BACKGROUND_REMOVER", { ns: "billing" });
          break;
        case FeatureCodes.AI_ASSISTANT:
          title = t("ai_feature_heading", { ns: "ai" });
          break;
        case FeatureCodes.BRANDKIT:
          title = t("feature_codes.BRANDKIT", { ns: "billing" });
          break;
        case FeatureCodes.DOWNLOAD_AS_SVG:
          title = t("feature_codes.DOWNLOAD_AS_SVG", { ns: "billing" });
          break;
        case FeatureCodes.CUSTOM_FONTS:
          title = t("feature_codes.CUSTOM_FONTS", { ns: "billing" });
          break;
        case FeatureCodes.PUBLISH_TEMPLATE:
          title = t("feature_codes.PUBLISH_TEMPLATE", { ns: "billing" });
          break;
        case FeatureCodes.SAVE_AS_TEMPLATE:
          title = t("feature_codes.SAVE_AS_TEMPLATE", { ns: "billing" });
          break;
        case FeatureCodes.AI_LONG_FORM_EDITOR:
          title = t("feature_codes.AI_LONG_FORM_EDITOR", { ns: "billing" });
          break;
        case FeatureCodes.PLANNER_NO_OF_SOCIAL_ACCOUNT:
          title = t("feature_codes.PLANNER_NO_OF_SOCIAL_ACCOUNT", {
            ns: "billing",
          });
          break;
        case FeatureCodes.BULK_UPLOAD:
          title = t("feature_codes.BULK_UPLOAD", { ns: "billing" });
          break;
        case FeatureCodes.PLANNER_NO_OF_POSTS:
          title = t("feature_codes.PLANNER_NO_OF_POSTS", { ns: "billing" });
          break;
        case FeatureCodes.AI_PLAGRISM_CHECKER:
          title = t("feature_codes.AI_PLAGRISM_CHECKER", { ns: "billing" });
          break;
        default:
          title = "";
          break;
      }

      return <>Upgrade to use {title}</>;
    };

    getFeatureLockModalFeatureList = () => {
      const { feature } = this.state;
      let featureList = [];
      const { t } = i18next;

      switch (feature) {
        case FeatureCodes.AI_LONG_FORM_EDITOR:
          featureList = [
            {
              icon: FaFileSignature,
              title: t("ai_feature_1", { ns: "ai" }),
              info: t("ai_feature_1_description", { ns: "ai" }),
            },
            {
              icon: FaPenAlt,
              title: t("ai_feature_2", { ns: "ai" }),
              info: t("ai_feature_2_description", { ns: "ai" }),
            },
            {
              icon: FaCheckDouble,
              title: t("ai_feature_3", { ns: "ai" }),
              info: t("ai_feature_3_description", { ns: "ai" }),
            },
          ];
          break;
        default:
          featureList = includedFeatures;
          break;
      }

      return featureList;
    };

    getFeatureLockModalImage = () => {
      const { feature } = this.state;
      let image = null;

      switch (feature) {
        case FeatureCodes.AI_LONG_FORM_EDITOR:
          image = aiLongFormArtBoard;
          break;
        case FeatureCodes.AI_ASSISTANT:
          image = aiLongFormArtBoard;
          break;
        default:
          break;
      }

      return image;
    };

    render() {
      const { show } = this.state;

      return (
        <>
          <WrappedComponent
            checkFeatureAvailability={(feature, callback, fileType) =>
              this.checkFeatureAvailability(feature, callback, fileType)
            }
            {...this.props}
          />

          {show ? (
            <div onClick={(e) => e.stopPropagation()}>
              <TldrUpgradeSubscriptionModal
                show={show}
                onHide={() => {
                  this.setState({
                    show: false,
                  });
                }}
                title={this.getFeatureLockModalTitle()}
                featureList={this.getFeatureLockModalFeatureList()}
                image={this.getFeatureLockModalImage()}
              ></TldrUpgradeSubscriptionModal>
            </div>
          ) : null}
        </>
      );
    }
  };
};

const mapStateToProps = (state) => ({
  subscription: state.subscription,
});

const mapDispatchToProps = (dispatch) => ({});

const connectedFeatureAvailabilityWrapper = compose(
  connect(mapStateToProps, mapDispatchToProps),
  FeatureAvailabilityWrapper
);

export default connectedFeatureAvailabilityWrapper;
